import useContractDayWise from './useInstrument';

export default function useContract(underlying) {
  const targetContract = useContractDayWise();

  if (!targetContract) {
    return '';
  }

  return targetContract[underlying];
}
